export class RegenradarBildMetadata {
  id: string;
  size: string;
  type: string;
  imageUrl: string;
  zeitstempel: Date;
  filename: string;


  constructor(size: string, type: string, imageUrl: string) {
    this.id = '_' + Math.random().toString(36).substr(2, 9);
    this.size = size;
    this.type = type;
    this.imageUrl = imageUrl;
    this.zeitstempel = this.getTimestampFromImageUrl();
    this.filename = this.getFilenameFromImageUrl();
  }

  //Holt den Zeitsempel aus der URL -> z.B. "2021-01-20T13:00:00"
  private getTimestampFromImageUrl() {
    return new Date(this.imageUrl.substring(this.imageUrl.lastIndexOf('/') + 1).split('.')[0]);
  }

  private getFilenameFromImageUrl() {
    return this.imageUrl.substring(this.imageUrl.lastIndexOf('/') + 1);

    //https://storage.googleapis.com/wetter-dts-dev-207755492.appspot.com/wetter/regenradar/bilder/aktuell/deutschland/l/2021-01-20T13:00:00_regenradar_tagesschau.de_gesamt_l.jpg

  }
}
